import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import React from "react";

export const SimpleConfirmDialog = (
  { open,
    title,
    text,
    onCancel,
    onConfirm,
  }:
    {
      open: boolean,
      title: string,
      text: string | JSX.Element,
      onCancel: () => void,
      onConfirm: () => void
    }
) => {

  return (<Dialog open={open} onClose={onCancel}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {text}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="secondary">
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
  );
}